<template>
  <section style="padding: 60px 0">
    <div style="margin-bottom: 60px">
      <bl-text-av class="mb-16" tag="h2" variation="heading-42" weight="bold" align="center">
        {{ $options.productList.title }}
      </bl-text-av>

      <bl-text-av style="font-size: 26px; line-height: 32px;" align="center">
        {{ $options.productList.subtitle }}
      </bl-text-av>
    </div>

    <div v-if="mutualFundProducts">
      <bl-flex-container-mv wrap="wrap" align-item="center" justify-content="center" style="max-width: 100%;">
        <bl-flex-item-av>
          <bl-card-mv style="width: 1218px;">
            <bl-flex-container-mv wrap="wrap" align-item="center" justify-content="center">
              <bl-flex-item-av class="pt-48 ph-24 pb-24" style="background-color: #F2F2F2">
                <article v-for="(product, index) in filteredProducts" :key="product.id">
                  <product-card
                    :style="index !== 0 ? 'margin-top: 40px' : ''"
                    :product="product"
                    :is-selected="product.id === selectedProduct.id"
                    @click="onProductCardClick"
                  />
                </article>
              </bl-flex-item-av>
              <bl-flex-item-av class="pt-48 ph-24 pb-24" :grow="1" :shrink="1">
                <bl-text-av class="mb-8" weight="semi-bold" style="font-size: 26px; line-height: 32px;">
                  {{ selectedProduct.name }}
                </bl-text-av>
                <bl-text-av class="mb-48" variation="subheading-20" weight="regular">
                  {{ formatChartDuration }}
                </bl-text-av>
                <div class="mb-48">
                  <bl-selection-block-mv
                    v-for="(date, index) in $options.dateOptions"
                    :key="index"
                    :text="date.name"
                    :is-selected="date.name === startDateObject.name"
                    :class="{ 'ml-4': index !== 0 }"
                    @select="setStartDate(date)"
                  />
                </div>
                <client-only>
                  <product-chart v-if="selectedProduct.id" :product="selectedProduct" :range="chartRange" />
                </client-only>
              </bl-flex-item-av>
            </bl-flex-container-mv>
          </bl-card-mv>
        </bl-flex-item-av>
      </bl-flex-container-mv>
    </div>
  </section>
</template>

<script>
/* istanbul ignore file */
import BlTextAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlTextAv';
import { ProductList as productList } from 'shared/modules/seo/Homepage';
import BlCardMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlCardMv';
import BlFlexContainerMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexItemAv';
import BlSelectionBlockMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlSelectionBlockMv';
import ProductCard from 'seo-desktop/components/ProductCard';
import ProductChart from 'seo-desktop/components/ProductChart';
import ClientOnly from 'vue-client-only';
import dayjs from 'dayjs';

export default {
  name: 'ProductList',

  productList,

  dateOptions: [
    {
      value: 7,
      name: '7 Hari',
    },
    {
      value: 30,
      name: '1 Bulan',
    },
    {
      value: 90,
      name: '3 Bulan',
    },
    {
      value: 365,
      name: '1 Tahun',
    },
  ],

  components: {
    BlTextAv,
    BlFlexContainerMv,
    BlFlexItemAv,
    BlCardMv,
    ProductCard,
    ProductChart,
    ClientOnly,
    BlSelectionBlockMv,
  },

  data() {
    return {
      selectedProduct: {},
      startDate: null,
      startDateObject: null,
      chartRange: 7,
    };
  },

  computed: {
    formatChartDuration() {
      return `${dayjs(this.startDate).format('DD MMMM YYYY')} - ${dayjs().format('DD MMMM YYYY')}`;
    },
    mutualFundProducts() {
      return this.$store.state.server.mutualFundProducts;
    },
    filteredProducts() {
      return this.mutualFundProducts && this.mutualFundProducts.filter(product => product.recommended);
    },
  },

  watch: {
    filteredProducts: {
      handler(value) {
        this.selectedProduct = value && value.length ? value[0] : {};
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    if (!this.$root.isSSR && !this.mutualFundProducts) {
      // Ignore error because
      this.$store.dispatch('server/retrieveMutualFundProducts');
    }
  },

  mounted() {
    this.setStartDate(this.$options.dateOptions[0]);
  },

  methods: {
    onProductCardClick(product) {
      this.selectedProduct = product;
    },

    setStartDate(date) {
      this.startDateObject = date;
      this.startDate = dayjs()
        .subtract(date.value, 'day')
        .toString();
      this.chartRange = date.value;
    },
  },
};
</script>
